// extracted by mini-css-extract-plugin
module.exports = {"fullSize":"application_card_base-module_fullSize_42fe8","halfSize":"application_card_base-module_halfSize_44f92"};